import request from '../utils/request';
import router from '../router/router';
import { MessageBox } from "element-ui";

// 登入
export function subimData(data) {
    return request({
        url: "/login1/login",
        method: "post",
        data
    })
}

// 首页
export function infoData(params) {
    return request({
        url: "/index/index",
        method: "get",
        params
    })
}
// 通讯录查询
export function inquireData(keywords) {
    return request({
        url: "/index/AddressBook",
        method: "get",
        params: {
            keywords
        }
    })
}
// 报名
export function applyData(url, ID, AID, type) {
    return request({
        url: url,
        method: "get",
        params: {
            ID,
            AID,
            type,
        }
    })
}

// 委员会列表
export function committeeData(params) {
    return request({
        url: "/index/CommitteeList",
        method: "get",
        params
    })
}

// 个人中心
export function centreData(params) {
    return request({
        url: "/index/updPersonal",
        method: "get",
        params,

    })
}
// 个人中心-请求最新用户信息
export function replaceData(AID) {
    return request({
        url: "/index/personal",
        method: "get",
        params: {
            AID
        }
    })
}
// 修改密码
export function passwordData(params) {
    return request({
        url: "/index/updPASSWORD",
        method: "get",
        params
    })
}
// 修改头像
export function headData(formData) {
    return request.post("/index/updHeadImg", formData, {
        headers: { "Content-Type": "multipart/form-data" }
    })
}






// 会员列表分页
export function pagingData(params) {
    return request({
        url: "/index/MemberList",
        method: "get",
        params
    })
}

/**
 * 下载execl名录
 */
export const downloadFile = (url, ext, params) => {
    return request({
        method: 'get',
        url: url,
        params,
        responseType: 'blob', //二进制流
    }).then(res => {
        // 处理返回的文件流
        const content = res;
        if (res.type === "text/xml") {
          // 将blob文件流转换成json
          const reader = new FileReader();
          reader.onload = function () {
            MessageBox.alert('你的密码已过期请重新登录!','警告', {
                confirmButtonText: '确定',
                type: 'warning',
                callback: () => {
                    router.push("/login");
                }
            })
          }
          reader.readAsText(content);
        }else{
            const blob = new Blob([content], { type: 'application/vnd.ms-excel;charset=utf-8' });
            var date =
                new Date().getFullYear() +
                "" +
                (new Date().getMonth() + 1) +
                "" +
                new Date().getDate() +
                "" +
                new Date().getHours() +
                "" +
                new Date().getMinutes() +
                "" +
                new Date().getSeconds() +
                "" +
                new Date().getMilliseconds();
            const fileName = '鉴定机构名录' + date + "." + ext;
            if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
            }
        }
    });
};

export const getRecordExport = (url, params) => {
    return downloadFile(url, "xlsx", params)
}